import React, { useState, useMemo } from 'react';
import { Document } from 'react-pdf/dist/entry.webpack';
import styled from 'styled-components';
import AllPDFPages from './AllPDFPages';

interface PDFDocumentProps {
  closeModalHandler: VoidFunction;
}

const StyledDocument = styled(Document)`
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const PDFDocument: React.FC<PDFDocumentProps> = ({ closeModalHandler }: any) => {
  const [pageAmount, setPageAmount] = useState(0);

  const onDocumentLoadSuccess = (file: any) => {
    const { numPages } = file;
    setPageAmount(numPages);
  };

  const file = useMemo(
    () => ({
      url: `${process.env.REACT_APP_BASE_URL}/users/common-file?filename=Needl_Terms_of_Use.pdf`,
    }),
    []
  );

  return (
    <StyledDocument
      file={file}
      onLoadSuccess={onDocumentLoadSuccess}
      loading={<div style={{ margin: '300px 300px' }}>Loading...</div>}
    >
      <AllPDFPages pageAmount={pageAmount} closeModalHandler={closeModalHandler} />
    </StyledDocument>
  );
};

export default PDFDocument;
